import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import dayjs from 'dayjs';
import { get } from 'lodash';
import { BehaviorSubject, catchError, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MonitoringService } from '../../core/error-handler/monitoring.service';
import { DateUtilitiesService } from '../../utilities/date-utilities.service';
import { IBaseResponse } from '../../utilities/http-utilities.service';
import { userActions } from './user.actions';
import { ICurrentUser } from './user.interface';
import { UserService } from './user.service';

@Injectable()
export class UserEffects {
  private static userSource: BehaviorSubject<ICurrentUser>;

  getCurrentUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userActions.getCurrentUser.type),
      switchMap(() =>
        this.service.getCurrentUser().pipe(
          switchMap((response: IBaseResponse<ICurrentUser>) => {
            UserEffects.userSource = new BehaviorSubject<ICurrentUser>(response.data);
            dayjs.locale(response.data.dfUserConfiguration.locale);
            dayjs.tz.setDefault(response.data.dfUserConfiguration.timezone);
            this.monitoringService.setAuthenticatedUser(String(response.data.id), window.location.hostname);

            return of(userActions.getCurrentUserCompleted({ user: response.data }));
          }),
        ),
      ),
      catchError((error) => {
        if (get(error, 'error.message.0.constraints.BadRequestException') === 'client-conflict-tenant-not-found') {
          alert(
            'The Digital Factory account you are logged in with is not registered in the Digital Boards system. Please check your Digital Factory account',
          );
        }

        return of();
      }),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly service: UserService,
    private readonly monitoringService: MonitoringService,
  ) {
    DateUtilitiesService.getNowInUTC();
  }

  public static getUser(): ICurrentUser {
    return this.userSource?.value;
  }
}
